import { CompassCardUI } from '@scale/compass-ui/types';
import {
  JoinContributorDataCardShared,
  type JoinContributorDataSchemaType,
  type JoinContributorDataContext,
  JOIN_CONTRIBUTOR_DATA,
} from '@scale/genai-compass-shared/cards/join_contributor_data';
import JoinContributorDataCardComponent from './JoinContributorDataCardComponent';
import { faUserPlus } from '@fortawesome/pro-solid-svg-icons';

const defaultContext: JoinContributorDataContext = {
  cardType: JOIN_CONTRIBUTOR_DATA,
  contributorIdsColumnName: '',
};

export const JoinContributorCardInfo: CompassCardUI<JoinContributorDataSchemaType> = {
  ...JoinContributorDataCardShared,
  title: 'Join Contributor Data',
  icon: 'people',
  toolTip: 'Join contributor data to the current dataset.',
  defaultContext,
  legacyComponent: JoinContributorDataCardComponent,
  button: {
    icon: faUserPlus,
  },
};
